import { Event } from '../Event'
import { ViewerContext } from '../../constants'

export interface PathQuestionViewedEventProperties {
  path_and_page_slugs: string
}

export class PathQuestionViewedEvent extends Event<PathQuestionViewedEventProperties> {
  static displayName = 'Path Question Viewed'

  static allowedViewerContexts = [ViewerContext.Consumer]
}
